import React, { useEffect, useState } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Login from '../EpicGame/Components/Login/login';
import "../EpicGame/Assets/styles/style.css";
import "../EpicGame/Assets/styles/addmenu.css";
import SignUp from '../EpicGame/Components/signup/signUp';
import Home from '../EpicGame/Pages/Home/homePage';
import OptimizationPage from '../EpicGame/Pages/Home/balancePage';
import RatingPageOBT from '../EpicGame/Pages/Home/ratingPage';
import PanelHome from '../AdminPanal/pages/Home/home';
import MainLayout from '../AdminPanal/Layouts/mainLayout';
import ContinuousPage from '../AdminPanal/pages/Home/productlist';
import AdminLogin from '../AdminPanal/pages/login/adminLogin';
import UserGradeListing from '../AdminPanal/pages/User Grade/userGrade';
import RegisterUser from '../AdminPanal/pages/userForm/userForm';
import HistoryPage from '../EpicGame/Pages/history/history';
import Dashboard from '../EpicGame/Pages/Dashboard/dashboard';
import Terms from '../EpicGame/Pages/terms/terms';
import GamePage from '../EpicGame/Pages/Home/gamePage';
import RechargePage from '../EpicGame/Pages/Home/rechargePahe';
import UserProfile from '../EpicGame/Pages/userProfile/userprofile';
import ResetPassword from '../EpicGame/Pages/userProfile/resetPassword';
import UpgradeUserLevel from '../EpicGame/Pages/Home/upgradeLevel';
import WalletInfo from '../EpicGame/Pages/history/walletInformation';
import AboutEpic from '../EpicGame/Pages/terms/abaout';
import FAQs from '../EpicGame/Pages/terms/faqs';
import Certificate from '../EpicGame/Pages/terms/certificate';
import Support from '../EpicGame/Pages/terms/support';
import WithdrawBalance from '../EpicGame/Pages/history/widthdrawPage';
import DashboardAdmin from '../AdminPanal/pages/Home/dashboard';
import AddDebit from '../AdminPanal/pages/Home/addDebit';

const AppRoutes = () => {
    const [itmData, setItems] = useState();

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setItems(items);
        }
    }, []);

    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/login" element={<Login />} />
                <Route path="/SignUp" element={<SignUp />} />
                <Route path="/Home" element={<Home />} />
                <Route path="/Optimization" element={<OptimizationPage />} />
                <Route path="/RatingObtimization" element={<RatingPageOBT />} />
                <Route path="/Play" element={<GamePage />} />
                <Route path="/Profile" element={<UserProfile />} />
                <Route path="/ResetPassword" element={<ResetPassword />} />
                <Route path="/UpgradeLevel" element={<UpgradeUserLevel />} />
                <Route path="/waletInfo" element={<WalletInfo />} />
                <Route path="/Withdrawal" element={<WithdrawBalance />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/About" element={<AboutEpic />} />
                <Route path="/Support" element={<Support />} />
                <Route path="/FAQs" element={<FAQs />} />
                <Route path="/Certificate" element={<Certificate />} />
                <Route path="/Recharge" element={<RechargePage />} />
                <Route path="/History" element={<HistoryPage />} />

                {/* Admin Routes */}
                {/* <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<MainLayout><DashboardAdmin /></MainLayout>} />
                <Route path="/UserList" element={<MainLayout><PanelHome /></MainLayout>} />
                <Route path="/Product/Listing" element={<MainLayout><ContinuousPage /></MainLayout>} />
                <Route path="/UserGrade" element={<MainLayout><UserGradeListing /></MainLayout>} />
                <Route path="/UserMaster" element={<MainLayout><RegisterUser /></MainLayout>} />
                <Route path="/Add_Debit" element={<MainLayout><AddDebit /></MainLayout>} /> */}
            </Routes>
        </HashRouter>
    );
};

export default AppRoutes;
